<template>
  <div>
          <div class="header-area">
            <h3>Examples of {{ popupData.name }}</h3>
          </div>
          <div class="block-list-holder">
            <div class="baron">
              <div style="padding-top: 3px" id="scrollable555" class="baron__scroller">
                <p class="error-message" v-if="popupData.timedOut">
                  Server took too long to respond.
                </p>
                <p class="error-message" v-if="popupData.failed">
                  Server failed to provide the necessary response.
                </p>
                <div v-if="popupData.allExamples.length > 1" class="examples-group">
                  <ul style="padding-bottom: 0">
                    <li style="float: inherit; margin: 0" v-for="groupOfExamples in popupData.allExamples.slice().reverse()" :key="parentName+'-link-'+groupOfExamples.id">
                      <a v-if="groupOfExamples.displayName && groupOfExamples.displayName.length > 0 && groupOfExamples.examples.length > 0" class="examples-link" v-bind:href="'#'+parentName+'-group-'+groupOfExamples.id">{{ groupOfExamples.displayName }}</a>
                    </li>
                  </ul>
                </div>
                <span v-if="popupData.loading"><br /><spinner></spinner></span>
                <div v-for="groupOfExamples in popupData.allExamples"
                    :key="parentName+groupOfExamples.id"
                    v-bind:id="parentName+'-group-'+groupOfExamples.id"
                    style="padding-top: 5px">
                  <div v-show="groupOfExamples.loaded && groupOfExamples.examples.length > 0"
                      style="text-align: right; padding: 10px 32px 0">
                    <p style="margin-bottom: 0">{{ groupOfExamples.displayName }}</p>
                    <hr style="margin-bottom: 0; margin-top: 5px" />
                  </div>
                  <ul style="padding: 8px 0" class="block-list" dir="rtl">
                    <li v-for="example in groupOfExamples.examples" :key="parentName+groupOfExamples.id+example.unitKey">
                      <em class="gray">{{ summarizeKeys([example.unitKey]) }}</em>
                      <p class="black" v-html="example.unitText"></p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="baron__track">
                <div class="baron__bar"></div>
              </div>
            </div>
          </div>
  </div>
</template>
<script>
import {prettyPrint} from '../../mixins/featureNames'
import textMixins from '../../mixins/textMixins'
import axios from 'axios/index'
import Spinner from '../spinner'
import {summarizeKeys} from '../../texts/index'
// import _ from 'lodash'

export default {
  name: 'FeatureExamples',
  components: { Spinner },
  props: ['feature'],
  data () {
    return {
      popupData: {
        name: '(not yet populated)',
        allExamples: [],
        loading: false,
        failed: false,
        timedOut: false
      }
    }
  },
  watch: {
    feature: function (newFeature) {
      console.log('running watcher')
      if (newFeature !== 'not yet') { this.initPopup(newFeature) }
    }
  },
  mixins: [textMixins],
  computed: {
    parentName () {
      return this.$parent.$vnode.tag
    }
  },
  methods: {
    prettyPrint,
    summarizeKeys,
    populatePopupData: function (featureObj) {
      // (might save unnecessary API calls) if (featureObj.name === this.popupData.name) { return }
      console.log('About to set "featureSettings" - heres what featureObj is:')
      console.log(featureObj)
      let featureSettings = this.$store.state.featureSettings[featureObj.featureType].settings.featureSettings
      /* const keyArray =
        _.flatMap(this.classes.concat(this.testText), text => text && text.keys ? text.keys : []) */
      const nameForRequest = (featureObj.featureName.slice(0, 7) === 'lexeme:') ? featureObj.featureName.slice(7) : featureObj.featureName
      this.classes.concat(this.testText).forEach(text => {
        this.popupData.allExamples.push({
          id: text.id,
          displayName: text.displayName,
          requestData: {
            'featureName': nameForRequest,
            'keys': text && text.keys ? text.keys : [],
            'featureSettings': featureSettings
          },
          loaded: false,
          examples: []
        })
        // (wasn't the right fix after all?) this.currentFeatureName = featureObj.name
      })
      this.popupData.allExamples.forEach(text => {
        this.populateByAPI(this.popupData, text.requestData, text.id)
      })
    },
    populateByAPI: function (pData, requestData, textId) {
      const url = process.env.SERVER_URL + '/DictaDatabaseServer/api/TextFeatures/FindFeature'
      const httpClient = axios.create()
      httpClient.defaults.timeout = 30000
      let responseData = httpClient.post(url, requestData).then(response => {
        console.log(response.data)
        // console.log('pData.name:')
        // console.log(pData.name)
        // console.log('requestData.featureName:')
        // console.log(requestData.featureName)
        if (!(Array.isArray(response.data))) {
          pData.loading = false
          pData.timedOut = false
          pData.failed = true
        } else {
          let allLoaded = true
          pData.allExamples.forEach(text => {
            if (text.id === textId) {
              if ((response.data.length > 0) && (response.data[0].hasOwnProperty('contents')) && (response.data[0].contents.length > 0)) {
                response.data.forEach(chunkContents => {
                  chunkContents.contents.forEach(content => {
                    text.examples.push({unitKey: content.smallUnit.chunkKey, unitText: content.smallUnit.text})
                  })
                })
              }
              text.loaded = true
            } else allLoaded = allLoaded && text.loaded
          })
          if (pData.loading && allLoaded) {
            pData.loading = false
            if (!(pData.allExamples.some(g => g.examples.length))) pData.failed = true
            console.log('fully populated pData:')
            console.log(pData)
          }
        }
      }).catch(error => {
        console.log(error)
        // pData.failed = false
        if (!(pData.failed)) pData.timedOut = true // failure "beats" timeout
        pData.loading = false
      })
      // return responseData
      console.log(responseData) // so it won't be an unused variable
    },
    initPopup: function (feature) {
      this.popupData.name = '"' + this.prettyPrint(feature.featureName) + '"'
      this.popupData.allExamples = []
      this.popupData.loading = true
      this.popupData.timedOut = false
      this.popupData.failed = false
      this.populatePopupData(feature)
    }
  }
}
</script>
<style scoped>
.error-message {
  padding-top: 30px !important;
}
.examples-group {
  background-color: #f0f0f0;
  text-align: right;
  height: 36px;
  padding-top: 7px;
  padding-right: 32px;
}
.examples-link {
  padding-top: 0;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
  float: right;
  list-style-type: none;
  padding-left: 15px;
  padding-right: 0;
  box-shadow: none;
  border: none;
  background-color: inherit;
  line-height: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/experiment/featureExamples.vue